export enum FeatureFlag {
  EnableMarket = 'enableMarket',
  EnableHomeSplitPane = 'enableHomeSplitPane',
  EnableTodayMovement = 'enableTodayMovement',
}

export const FEATURE_FLAGS = {
  [FeatureFlag.EnableMarket]: false,
  [FeatureFlag.EnableHomeSplitPane]: false,
  [FeatureFlag.EnableTodayMovement]: false,
} as const satisfies Record<FeatureFlag, boolean>;

export type FeatureFlags = Record<FeatureFlag, boolean>;
